import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterIds,
  handleToggleCollapsed,
  handleSetSelectedContentBasedValues,
  handleChangeSortBy,
  handleSetSelectedFilterValue,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './resourceHelpers';
import { instagramFiltersInitialState } from './initialState/InstagramInitialState';

export { instagramFiltersInitialState as filtersInitialState };

export const instagramSearchResourceInitialState = {
  filters: instagramFiltersInitialState,
  sortBy: {
    selected: 'follower_count',
    order: 'desc',
  },
  selectedFilter: 'contentBasedFilter',
};
export const instagramSearchResourceSlice = createSlice({
  name: 'instagramSearchResourceSlice',
  initialState: instagramSearchResourceInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, instagramFiltersInitialState);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = instagramFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, instagramFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  setSelectedContentBasedValues,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = instagramSearchResourceSlice.actions;
